'use client';

import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import {
  isStandardAllergen,
  type CustomAllergen
} from '../../allergy-matrix/allergens';

/** A column's label: translated for standard keys, as typed for custom ones. */
export function useAllergenLabel(customAllergens: readonly CustomAllergen[]) {
  const t = useTranslations('allergy-matrix.allergens');
  return useCallback(
    (key: string) => {
      if (isStandardAllergen(key)) {
        return t(key);
      }
      return (
        customAllergens.find(column => column.key === key)?.label ??
        key.replace(/^custom_/, '').replace(/_/g, ' ')
      );
    },
    [customAllergens, t]
  );
}
